// extracted by mini-css-extract-plugin
module.exports = {"text":"textBackground_text__oQeWC","revert":"textBackground_revert__ChXFE"};